import {ApigetWebsiteinfo} from '@api/service'
export default {
    namespaced: true,
    state: {
        isCache: false, //是否已缓存
        info: {}, //站点信息（帮助中心）
    },
    mutations: {
        setIsCache (state,data) {
            state.isCache = data;
        },
        setInfo (state,data) {
            state.info = data;
        },
    },
    actions: {
        getWebsiteinfo(context) {
            // if(!context.state.isCache) {
                context.commit("setIsCache", true);
                ApigetWebsiteinfo().then(res => {
                    if(res.code == '12200'){
                        context.commit("setInfo", res.data);
                    }
                }).catch(()=> {
                    context.commit("setIsCache", false);
                })
            // }
        }
    }
}